import PropTypes from 'prop-types';

export const PHOTO_OBJECT_TYPE = PropTypes.shape({
    altText: PropTypes.string,
    caption: PropTypes.string,
    url: PropTypes.string,
    credit: PropTypes.string
});
